import { LOCALES, type Locale } from '@fdt/shared';
import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { currentLocale, setLocale } from '../i18n';

const LABELS: Record<Locale, string> = { it: 'Italiano', tr: 'Türkçe' };

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  return (
    <TextField
      select
      size="small"
      value={currentLocale()}
      onChange={(event) => setLocale(event.target.value as Locale)}
      label={t('common.language')}
      sx={{ minWidth: 120 }}
      // Re-render when the language changes so the selected value stays in sync.
      key={i18n.language}
    >
      {LOCALES.map((locale) => (
        <MenuItem key={locale} value={locale}>
          {LABELS[locale]}
        </MenuItem>
      ))}
    </TextField>
  );
}
